// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariIndex from '@/pages/mercari-index/components/_MercariIndex.vue'

hybridPage()

createApp({
	name: 'Mercari Index Page',
	components: {
		MercariIndex,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariIndex)

		const { mercariIndexPageContent } = window.pageContent

		return {
			mercariIndexPageContent,
		}
	},
}).mount('#bsMain')
